import * as React from 'react';
import styled from 'styled-components';
import { hexToRgb } from '@latitude/core/helpers';
import { COLOR } from '@latitude/core/utils/constants';
import { AnalyticsLocationConsumer } from '@latitude/analytics-location';
import { withEventTracking } from 'react-event-tracker';
import { formatTelNo } from './Tel.helpers';

// styled-components pass through any known HTML attributes to the DOM. Renaming some props to avoid this.

const StyledComponent = /*#__PURE__*/styled.a.withConfig({
  displayName: "Tel__StyledComponent",
  componentId: "sc-1y94rr7-0"
})(["cursor:pointer;white-space:nowrap;", ";", ";"], _ref => {
  let {
    noStyle
  } = _ref;
  return noStyle && `border: none !important;
     color: inherit !important;
     text-decoration: none !important;
     :hover {
      text-shadow: none !important;
     }
  `;
}, _ref2 => {
  let {
    cssColor,
    noStyle
  } = _ref2;
  return !noStyle && cssColor && `color: ${cssColor} !important;
     border-bottom: solid 1px rgba(${hexToRgb(cssColor)}, 0.5) !important;
     :hover {
       transition: all .15s ease-in-out;
       text-shadow: 0 0 1px rgba(${hexToRgb(cssColor)}, 1) !important;
       border-bottom-color: rgba(${hexToRgb(cssColor)}, 1) !important;
     }
  `;
});
const Tel = _ref3 => {
  let {
    id,
    className,
    color,
    no,
    noStyle,
    trackEvent
  } = _ref3;
  const props = {
    id,
    className,
    cssColor: color,
    no,
    noStyle,
    trackEvent
  };
  return /*#__PURE__*/React.createElement(AnalyticsLocationConsumer, null, location => {
    const trackClick = () => {
      if (trackEvent) {
        trackEvent({
          event: {
            location,
            category: 'contact-us',
            action: 'phone-link',
            label: no
          }
        });
      }
    };
    return /*#__PURE__*/React.createElement(StyledComponent, Object.assign({}, props, {
      href: `tel:${formatTelNo(props.no)}`,
      onClick: trackClick
    }), props.no);
  });
};
export default withEventTracking(Tel);